import apiInstance, { cachedApiInstance } from "api";
import { apiInstanceFileUpload } from "api";
import list from "assets/theme/components/list";

export const OrganizationService = {
  createOrganization: async (body) => {
    return await apiInstance.post("/organizations", body);
  },

  getOrganizations: async (fitlers) => {
    return await apiInstance.get(`/organizations`, {
      params: {
        ...fitlers,
      },
    });
  },

  editOrganization: async (organizationId, body) => {
    return await apiInstance.put(`/organizations/${organizationId}`, body);
  },

  deleteOrganization: async (organizationId) => {
    return await apiInstance.delete(`/organizations/${organizationId}`);
  },

  makePrimaryOrganization: async (organizationId) => {
    return await apiInstance.put(`/organizations/${organizationId}/make-primary`);
  },
  getOrganizationsList: async (signal) => {
    return await apiInstance.get("/organizations/list", { signal });
  },
  getOrganizationUsers: async (fitlers) => {
    return await apiInstance.get(`/organizations/users`, {
      params: {
        ...fitlers,
      },
    });
  },
  getAllUsersList: async (fitlers) => {
    return await apiInstance.get(`/organizations/users/list`, {
      params: {
        ...fitlers,
      },
    });
  },
  getOrganizationVendors: async (fitlers) => {
    return await apiInstance.get(`/organizations/vendors`, {
      params: {
        ...fitlers,
      },
    });
  },
  getOrganizationVendor: async (vendorId) => {
    return await apiInstance.get(`/organizations/vendors/${vendorId}`);
  },
  getContacts: async (vendorId) => {
    return await apiInstance.get(`/organizations/users/${vendorId}/contacts`);
  },
  createContact: async (vendorId, body) => {
    return await apiInstance.post(`/organizations/users/${vendorId}/contacts`, body);
  },
  updateContact: async (vendorId, body) => {
    return await apiInstance.put(`/organizations/users/${vendorId}/contacts`, body);
  },
  deleteContact: async (vendorId, contactId) => {
    return await apiInstance.delete(`/organizations/users/${vendorId}/contacts/${contactId}`);
  },
  getAddresses: async (vendorId) => {
    return await apiInstance.get(`/organizations/users/${vendorId}/addresses`);
  },
  createAddress: async (vendorId, body) => {
    return await apiInstance.post(`/organizations/users/${vendorId}/addresses`, body);
  },
  updateAddress: async (vendorId, body) => {
    return await apiInstance.put(`/organizations/users/${vendorId}/addresses`, body);
  },
  deleteAddress: async (vendorId, addressId) => {
    return await apiInstance.delete(`/organizations/users/${vendorId}/addresses/${addressId}`);
  },
  getOrganizationCustomers: async (fitlers) => {
    return await apiInstance.get(`/organizations/customers`, {
      params: {
        ...fitlers,
      },
    });
  },
  getOrganizationUser: async (userId) => {
    return await apiInstance.get(`/organizations/user/${userId}`);
  },
  getVendorsList: async (fitlers = {}) => {
    return await apiInstance.get(`/organizations/vendors/list`, {
      params: {
        ...fitlers,
      },
    });
  },
  getCustomersList: async (fitlers = {}) => {
    return await apiInstance.get(`/organizations/customers/list`, {
      params: {
        ...fitlers,
      },
    });
  },
  createCustomer: async (body) => {
    return await apiInstance.post("/organizations/customers", body);
  },
  sendLoginDetails: async (body) => {
    return await apiInstance.post("/organizations/login-details/send", body);
  },
};

export const InvitationService = {
  createInvitation: async (body) => {
    return await apiInstance.post("/invited-users", body);
  },

  getInvitaions: async (fitlers) => {
    return await apiInstance.get(`/invited-users`, {
      params: {
        ...fitlers,
      },
    });
  },

  resendInvitation: async (body) => {
    return await apiInstance.post(`/invited-users/resend-invite`, body);
  },

  deleteInvitation: async (invitaionId) => {
    return await apiInstance.delete(`/invited-users/${invitaionId}`);
  },

  getInvitation: async (invitaionId) => {
    return await apiInstance.get(`/invited-users/get-invited-by-token/${invitaionId}`);
  },
  acceptInvitation: async (invitaionId) => {
    return await apiInstance.post(`/invited-users/accept-invite?token=${invitaionId}`);
  },
  createPassword: async (body) => {
    return await apiInstance.post(`/invited-users/create-password`, body);
  },
};

export const PermissionService = {
  createPermission: async (body) => {
    return await apiInstance.post("/roles-permissions/location-permissions", body);
  },

  getPermissions: async (roleId) => {
    return await apiInstance.get(`/roles-permissions/location-permissions/${roleId}`);
  },
  getAssetsPermissions: async (fitlers) => {
    return await apiInstance.get(`/roles-permissions/assets-permissions`, {
      params: {
        ...fitlers,
      },
    });
  },
  storeAssetsPermissions: async (body) => {
    return await apiInstance.post(`/roles-permissions/assets-permissions`, body);
  },
};

export const TeamsApiService = {
  createTeam: async (body) => {
    return await apiInstance.post("/organizations/teams", body);
  },
  updateTeam: async (body) => {
    return await apiInstance.put("/organizations/teams", body);
  },

  getPermissions: async (roleId) => {
    return await apiInstance.get(`/roles-permissions/location-permissions/${roleId}`);
  },
  getTeams: async (fitlers) => {
    return await apiInstance.get(`/organizations/teams`, {
      params: {
        ...fitlers,
      },
    });
  },
  getTeamUsers: async (teamId, fitlers) => {
    return await apiInstance.get(`/organizations/teams/${teamId}/users`, {
      params: {
        ...fitlers,
      },
    });
  },
  addTeamUser: async (teamId, body) => {
    await apiInstance.post(`/organizations/teams/${teamId}/users`, body);
  },
  removeTeamUser: async (teamId, userId) => {
    await apiInstance.delete(`/organizations/teams/${teamId}/users/${userId}`);
  },
};

export const WorkOrdersApiService = {
  createWorkOrder: async (body) => {
    return await apiInstanceFileUpload.post("/work-orders", body);
  },
  getWorkOrder: async (fitlers) => {
    return await apiInstance.get(`/work-orders`, {
      params: {
        ...fitlers,
      },
    });
  },
  searchWorkOrders: async (filters) => {
    return await apiInstance.get(`/work-orders/search`, {
      params: {
        ...filters,
      },
    });
  },
  getWorkOrderDetails: async (id) => {
    return await apiInstance.get(`/work-orders/${id}`);
  },
  createComment: async (id, body) => {
    return await apiInstanceFileUpload.post(`/work-orders/${id}/comments`, body);
  },
  updateStatus: async (id, body) => {
    return await apiInstance.put(`/work-orders/${id}/status`, body);
  },
  updateWorkOrderDetails: async (id, body) => {
    return await apiInstance.put(`/work-orders/${id}/details`, body);
  },
  updatePriority: async (id, body) => {
    return await apiInstance.put(`/work-orders/${id}/priority`, body);
  },
  updateAssignedTo: async (id, body) => {
    return await apiInstanceFileUpload.put(`/work-orders/${id}/assign`, body);
  },
  updateAsset: async (id, body) => {
    return await apiInstance.put(`/work-orders/${id}/asset`, body);
  },
  getParts: async (queryParams) => {
    return await apiInstance.get("/work-orders/parts", {
      params: {
        ...queryParams,
      },
    });
  },
  getWorkOrderParts: async (workOrderId) => {
    return await apiInstance.get(`/work-orders/${workOrderId}/parts`);
  },
  addWorkOrderPart: async (body) => {
    return await apiInstance.post("/work-orders/parts", body);
  },
  deleteWorkOrderPart: async (workOrderId, id) => {
    return await apiInstance.delete(`/work-orders/${workOrderId}/parts/${id}`);
  },
};

export const SubWorkOrderApiService = {
  createSubWorkOrder: async (body) => {
    return await apiInstance.post("/sub-work-orders", body);
  },
  getSubWorkOrders: async (parentWorkOrderId) => {
    return await apiInstance.get(`/sub-work-orders/${parentWorkOrderId}`);
  },
  deleteSubWorkOrder: async (id) => {
    return await apiInstance.delete(`/sub-work-orders/${id}`);
  },
};

export const TicketWorkOrderApiService = {
  createTicketWorkOrder: async (body) => {
    return await apiInstance.post("/ticket-work-orders", body);
  },
  getTicketWorkOrders: async (ticketId) => {
    return await apiInstance.get(`/ticket-work-orders/${ticketId}`);
  },
  deleteTicketWorkOrder: async (id) => {
    return await apiInstance.delete(`/ticket-work-orders/${id}`);
  },
};

export const TaskWorkApiService = {
  createTaskWork: async (body) => {
    return await apiInstanceFileUpload.post("/task-works", body);
  },
  getTaskWorks: async (fitlers) => {
    return await apiInstance.get(`/task-works`, {
      params: {
        ...fitlers,
      },
    });
  },
  getTaskWork: async (id) => {
    return await apiInstance.get(`/task-works/${id}`);
  },
  createComment: async (id, body) => {
    return await apiInstanceFileUpload.post(`/task-works/${id}/comments`, body);
  },
  updateStatus: async (id, body) => {
    return await apiInstance.put(`/task-works/${id}/status`, body);
  },
  updatePriority: async (id, body) => {
    return await apiInstance.put(`/task-works/${id}/priority`, body);
  },
  updateAssignedTo: async (id, body) => {
    return await apiInstanceFileUpload.put(`/task-works/${id}/assign`, body);
  }
};

export const PartsApiService = {
  getParts: async (queryParams) => {
    return await apiInstance.get("/parts", {
      params: {
        ...queryParams,
      },
    });
  },
  addPart: async (body) => {
    return await apiInstanceFileUpload.post("/parts", body);
  },
  getPart: async (PartId) => {
    return await apiInstance.get(`/parts/${PartId}`);
  },
  editPart: async (body) => {
    return await apiInstanceFileUpload.put(`/parts`, body);
  },
  deletePart: async (PartId) => {
    return await apiInstance.delete(`/parts/${PartId}`);
  },
  deleteFile: async (fileId) => {
    return await apiInstance.delete(`/parts/file/${fileId}`);
  },
  updateStatus: async (body) => {
    return await apiInstance.put(`/parts/status`, body);
  },
  getPartsList: async (fitlers = {}) => {
    return await apiInstance.get(`/parts/list`, {
      params: {
        ...fitlers,
      },
    });
  },
  // --- Part → model links ---------------------------------------------------
  // The models a part fits. The systems a part shows chips for are derived
  // from these; there is no way to set a part's systems directly.
  //
  // JSON, not multipart — only addPart/editPart need apiInstanceFileUpload.

  // Systems this org can link in: entitled AND owns at least one model there.
  // → { data: [{ system, displayName, targetKind, targetCount }] }
  getLinkableSystems: async () => {
    return await apiInstance.get("/parts/linkable-systems");
  },
  // Models available to link for one system. LCP returns the org's own lift
  // models (from /lcp/resources/lift-models) plus the global catalog, own
  // first; `isGlobal` marks which is which. Linking to a global lift does not
  // make the part global — the link row is org-stamped.
  // → { data: [{ targetKind, targetKey, label, manufacturer, modelNumber,
  //              isGlobal }] }
  getLinkTargets: async (system, search) => {
    return await apiInstance.get("/parts/link-targets", {
      params: { system, ...(search ? { search } : {}) },
    });
  },
  // → { data: [{ id, system, targetKind, targetKey, targetLabel, targetExists }] }
  getPartTargets: async (partId) => {
    return await apiInstance.get(`/parts/${partId}/targets`);
  },
  // Replaces the whole set — an empty array clears every link. Returns the
  // saved set with labels resolved, so no follow-up GET is needed.
  savePartTargets: async (partId, targets) => {
    return await apiInstance.put(`/parts/${partId}/targets`, { targets });
  },

  getPartTypes: async (fitlers = {}) => {
    return await apiInstance.get(`/parts/part-types`, {
      params: {
        ...fitlers,
      },
    });
  },
  getPartTypesAll: async (fitlers = {}) => {
    return await apiInstance.get(`/parts/part-types/all`, {
      params: {
        ...fitlers,
      },
    });
  },
  addPartType: async (body = {}) => {
    return await apiInstance.post("/parts/part-types", body);
  },
  updatePartType: async (body = {}) => {
    return await apiInstance.put("/parts/part-types", body);
  },
  deletePartType: async (id) => {
    return await apiInstance.delete(`/parts/part-types/${id}`);
  },
};

export const OrganizationCompanyApiService = {
  add: async (body) => {
    return await apiInstance.post(`/organization/companies/`, body);
  },
  listing: async (fitlers) => {
    return await apiInstance.get(`/organization/companies`, {
      params: {
        ...fitlers,
      },
    });
  },
  update: async (body) => {
    return await apiInstance.put(`/organization/companies`, body);
  },
  delete: async (id) => {
    return await apiInstance.delete(`/organization/companies/${id}`);
  },
  get: async (id) => {
    return await apiInstance.get(`/organization/companies/${id}`);
  },
};

export const OrganizationAddressApiService = {
  add: async (body) => {
    return await apiInstance.post(`/organization/companies/addresses/`, body);
  },
  listing: async (fitlers) => {
    return await apiInstance.get(`/organization/companies/addresses`, {
      params: {
        ...fitlers,
      },
    });
  },
  update: async (body) => {
    return await apiInstance.put(`/organization/companies/addresses`, body);
  },
  delete: async (id) => {
    return await apiInstance.delete(`/organization/companies/addresses/${id}`);
  },
  get: async (id) => {
    return await apiInstance.get(`/organization/companies/addresses/${id}`);
  },
  list: async (fitlers) => {
    return await apiInstance.get(`/organization/companies/addresses/list`, {
      params: {
        ...fitlers,
      },
    });
  },
};